module.exports = __webpack_public_path__ + "static/media/997700.153d5488.jpg";